module.exports = __webpack_public_path__ + "img/home-12.5b67374d.png";